import sumBy from 'lodash/sumBy';
import filter from 'lodash/filter';

export const domainsSelectList = state => state.domains ? [{ domain: 'viralstyle.com', domain_id: 'VS' }, ...state.domains] : [];

export const activeDomainsSelectList = state => state.domains ? [{ domain: 'viralstyle.com', domain_id: 'VS' }, ...filter(state.domains, domain => domain.active)] : [];

export const activeDomainsCount = state => sumBy(state.domains, domain => domain.active);

export const activeDomains = state => filter(state.domains, domain => domain.active);